import axios from 'axios';

const createApi = () => axios.create({
  baseURL: localStorage.getItem('isInternal') === '0'
    ? process.env.VUE_APP_API_URL
    : process.env.VUE_APP_API_GRP_URL,
});

export default createApi;
